/** Human-readable labels for subscription billing intervals (months). */

export function formatRecurrenceInterval(months?: number | null): string {
  if (!months || months < 1) return "";
  switch (months) {
    case 1:
      return "/mês";
    case 3:
      return "/trimestre";
    case 6:
      return "/semestre";
    case 12:
      return "/ano";
    default:
      return `/ ${months} meses`;
  }
}

export function formatRecurrenceIntervalLong(months?: number | null): string {
  if (!months || months < 1) return "ciclo";
  switch (months) {
    case 1:
      return "mensal";
    case 3:
      return "trimestral";
    case 6:
      return "semestral";
    case 12:
      return "anual";
    default:
      return `a cada ${months} meses`;
  }
}
